import React, { useState } from 'react';
import { Phone, Mail, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="text-3xl font-bold text-gray-900">
              SIA <span className="text-gray-600">Grúas</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors"
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('servicios')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors"
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('nosotros')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors"
            >
              Sobre Nosotros
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors"
            >
              Contacto
            </button>
          </nav>

          {/* Contact Info Desktop */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:2612073173" className="flex items-center text-gray-700 hover:text-gray-900 transition-colors">
              <Phone className="w-4 h-4 mr-2" />
              <span className="text-sm font-medium">261-2073173</span>
            </a>
            <Button 
              onClick={() => scrollToSection('contacto')}
              className="bg-gray-900 text-white hover:bg-gray-800"
            >
              Contactar
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-gray-700"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            <nav className="flex flex-col space-y-3">
              <button
                onClick={() => scrollToSection('inicio')}
                className="text-left text-gray-700 hover:text-gray-900 font-medium py-2"
              >
                Inicio
              </button>
              <button
                onClick={() => scrollToSection('servicios')}
                className="text-left text-gray-700 hover:text-gray-900 font-medium py-2"
              >
                Servicios
              </button>
              <button
                onClick={() => scrollToSection('nosotros')}
                className="text-left text-gray-700 hover:text-gray-900 font-medium py-2"
              >
                Sobre Nosotros
              </button>
              <button
                onClick={() => scrollToSection('contacto')}
                className="text-left text-gray-700 hover:text-gray-900 font-medium py-2"
              >
                Contacto
              </button>
              <div className="flex flex-col space-y-2 pt-2 border-t border-gray-200">
                <a href="tel:2612073173" className="flex items-center text-gray-700">
                  <Phone className="w-4 h-4 mr-2" />
                  <span className="text-sm">261-2073173</span>
                </a>
                <a href="tel:2613840960" className="flex items-center text-gray-700">
                  <Phone className="w-4 h-4 mr-2" />
                  <span className="text-sm">261-3840960</span>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
